import { render, staticRenderFns } from "./EditAccountPropDialog.vue?vue&type=template&id=134ee0ea&"
import script from "./EditAccountPropDialog.vue?vue&type=script&lang=js&"
export * from "./EditAccountPropDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports